import "../styles/admin.scss";
import "../styles/application.scss";
import "../utils/InitRailsUJS";
import "../utils/InitActiveStorage";
import "../utils/cable";
import ReactOnRails from "react-on-rails";

import AdminApp from "../components/AdminApp";

ReactOnRails.register({ App: AdminApp });
